
import React from 'react';
import { Link } from 'react-router-dom';
import { WorldCountry } from '@/data/countries/types';

interface CountryCallToActionProps {
  country: WorldCountry;
}

const CountryCallToAction = ({ country }: CountryCallToActionProps) => {
  return (
    <div className="mt-12 p-6 bg-brand-gray-50 rounded-xl">
      <h3 className="text-xl font-semibold text-brand-gray-900 mb-4">
        Ready to Connect with the Best Psychotherapists in {country.name}?
      </h3>
      <p className="text-brand-gray-700 mb-4">
        Take the next step in your mental health journey by connecting with the best 
        psychotherapists in {country.name}. Our platform makes it easy to find, compare, 
        and book appointments with qualified mental health professionals.
      </p>
      <div className="flex flex-wrap gap-4">
        <Link 
          to="/specialties" 
          className="py-2 px-4 bg-white shadow-sm hover:shadow border border-brand-gray-200 rounded-lg text-brand-gray-800 transition-all"
        >
          Browse by Specialty
        </Link>
        <Link 
          to="/how-it-works" 
          className="py-2 px-4 bg-white shadow-sm hover:shadow border border-brand-gray-200 rounded-lg text-brand-gray-800 transition-all"
        >
          How Our Service Works
        </Link>
        <Link 
          to="/" 
          className="py-2 px-4 bg-white shadow-sm hover:shadow border border-brand-gray-200 rounded-lg text-brand-gray-800 transition-all"
        >
          Available Online Now
        </Link>
      </div>
    </div>
  );
};

export default CountryCallToAction;
